import { createReducer } from "@reduxjs/toolkit";
const initialState = {
    isLoading: false,
  };

  const aboutUsReducer = createReducer(initialState, (builder) => {
    builder
      .addCase("get_all_aboutus_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_all_aboutus_success", (state,action) => {
        state.isLoading = false;
        state.AllAboutUs = action.payload;
      })
      .addCase("get_all_aboutus_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_aboutus_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_aboutus_success", (state,action) => {
        state.isLoading = false;
        state.aboutUsData = action.payload;
      })
      .addCase("get_aboutus_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      });
  });
  
  export default aboutUsReducer;